import { render, staticRenderFns } from "./CallbackWooCommerce.vue?vue&type=template&id=3407a032"
import script from "./CallbackWooCommerce.vue?vue&type=script&lang=ts"
export * from "./CallbackWooCommerce.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports